import Column from '@components/Column';
import CustomBarcode from '@components/CustomBarcode';
import Text from '@components/Text';

interface Props {
    couponNo: string;
}

function CouponBarcode({ couponNo }:Props) {
    return (
        <Column fullWidth align='center' spacing={1}>
            <CustomBarcode value={couponNo}
                height={40} />
            <Text size='body-long'>{couponNo}</Text>
        </Column>
    );
}

export default CouponBarcode;
